export const mockData = {
  hero: {
    name: "AKHIL JAIN",
    title: "Algorithmic Trading Expert",
    description: "Dynamic technology leader with 15+ years of experience building scalable trading solutions, managing teams, and driving innovation across fintech and education sectors."
  },
  
  about: {
    title: "About Me",
    content: "I'm a passionate technology professional with over 15 years of experience bridging the gap between complex algorithmic trading systems and business success. Currently leading backend engineering at AlgoBulls Ltd., I've helped grow the client base from 0 to 40K+ users through innovative trading solutions and robust API integrations.\n\nMy journey spans from quality assurance at Infosys to lecturing at Mumbai University, ultimately specializing in algorithmic trading systems. I thrive on solving complex problems, leading technical teams, and delivering cutting-edge solutions that make a real impact in the financial technology space.",
    highlights: [
      "Led team growth from 0 to 40K+ trading clients",
      "Integrated APIs with 40+ Indian and US broking houses",
      "15+ years across IT and education industries",
      "Expert in cloud migration and scalable architectures"
    ]
  },

  skills: {
    title: "Technical Skills",
    categories: [
      {
        name: "Programming",
        skills: ["Python", "PL/SQL", "Algorithmic Trading", "Data Structures & Algorithms"]
      },
      {
        name: "Cloud & Infrastructure",
        skills: ["Amazon Web Services (AWS)", "Docker", "CI/CD Pipelines", "DynamoDB"]
      },
      {
        name: "Databases & APIs",
        skills: ["NoSQL", "SQL", "RESTful APIs", "Time-series Data"]
      },
      {
        name: "Trading & Finance",
        skills: ["Equity Trading", "Options Trading", "F&O Strategies", "Market Analysis"]
      },
      {
        name: "Testing & Automation",
        skills: ["Selenium", "Automated Testing", "Quality Assurance", "Performance Testing"]
      },
      {
        name: "Leadership",
        skills: ["Team Management", "Strategy Development", "Cross-functional Collaboration", "Agile Methodologies"]
      }
    ]
  },

  experience: [
    {
      id: 1,
      title: "Senior Backend Engineer",
      company: "AlgoBulls Ltd.",
      location: "Mumbai",
      period: "2021 - Present",
      type: "Full-Time",
      description: "Leading algorithmic trading strategy development and team management, driving exponential client growth through innovative solutions.",
      achievements: [
        "Grew client base from 0 to 40K+ users with zero paid marketing",
        "Integrated APIs with 40+ Indian broking houses and US brokers",
        "Migrated infrastructure to cloud-based serverless NoSQL database",
        "Streamlined CI/CD pipelines with Docker and automation",
        "Developed advanced trading strategies for global markets"
      ]
    },
    {
      id: 2,
      title: "Strategy Developer",
      company: "AlgoBulls Ltd.",
      location: "Mumbai",
      period: "2019 - 2020",
      type: "Part-Time",
      description: "Focused on automated signal processing and order placement systems for equity markets.",
      achievements: [
        "Automated signal processing and order placement",
        "Designed infrastructure for historical data storage",
        "Supported strategy computations and market predictions"
      ]
    },
    {
      id: 3,
      title: "Lecturer",
      company: "Mumbai University",
      location: "Mumbai",
      period: "2012 - 2021",
      type: "Full-Time",
      description: "Delivered comprehensive lectures on advanced Computer Science subjects and managed academic examination processes.",
      achievements: [
        "Taught AI, Ethical Hacking, Cryptography, and Data Structures",
        "Served as external examiner across multiple colleges",
        "Managed practical exams and paper corrections"
      ]
    },
    {
      id: 4,
      title: "Technology Analyst",
      company: "Infosys Ltd.",
      location: "Mysore/Pune",
      period: "2007 - 2011",
      type: "Full-Time",
      description: "Led quality assurance and automation efforts for Microsoft Silverlight applications, ensuring defect-free product delivery.",
      achievements: [
        "Delivered defect-free Silverlight web application for Microsoft",
        "Developed automated testing framework for RPC modules",
        "Conducted root cause analyses and quality improvements",
        "Experience with Agile and Waterfall methodologies"
      ]
    }
  ],

  projects: [
    {
      id: 1,
      title: "Multi-Conditional Trading Algorithm Engine",
      description: "Designed and implemented complex algorithmic trading solutions supporting multiple market conditions and strategies.",
      technologies: ["Python", "AWS", "DynamoDB", "Real-time APIs"],
      highlights: ["40K+ active users", "Zero marketing spend growth", "Multi-market support"],
      status: "Production"
    },
    {
      id: 2,
      title: "Global Broker API Integration Platform",
      description: "Comprehensive API integration system connecting 40+ Indian and US broking houses for seamless trading operations.",
      technologies: ["RESTful APIs", "Python", "Docker", "CI/CD"],
      highlights: ["40+ broker integrations", "US & Indian markets", "Equity & Options support"],
      status: "Production"
    },
    {
      id: 3,
      title: "Cloud-Native Time-Series Data Infrastructure",
      description: "Migrated legacy systems to serverless cloud architecture for enhanced scalability and robust backtesting capabilities.",
      technologies: ["AWS", "DynamoDB", "Serverless", "NoSQL"],
      highlights: ["Cloud migration", "Scalable architecture", "Advanced backtesting"],
      status: "Production"
    },
    {
      id: 4,
      title: "Automated Testing Framework for Trading Systems",
      description: "Comprehensive testing and quality assurance framework ensuring reliability of trading algorithms and market integrations.",
      technologies: ["Selenium", "Python", "Automated Testing", "CI/CD"],
      highlights: ["Zero-defect deployments", "Automated QA", "Performance testing"],
      status: "Production"
    },
    {
      id: 5,
      title: "F&O Trading Strategy Suite",
      description: "Advanced futures and options trading strategies designed for global markets with regulatory compliance features.",
      technologies: ["Python", "Market Analysis", "Options Pricing", "Risk Management"],
      highlights: ["Global markets", "Regulatory compliance", "Advanced strategies"],
      status: "Production"
    },
    {
      id: 6,
      title: "Real-Time Market Data Processing System",
      description: "High-performance system for processing live market data, supporting candlestick patterns and LTP-based trading models.",
      technologies: ["Python", "Real-time Processing", "Market Data APIs", "Pattern Recognition"],
      highlights: ["Real-time processing", "Pattern recognition", "High performance"],
      status: "Production"
    }
  ],

  education: [
    {
      degree: "M.Sc (Computer Science)",
      institution: "Thakur College, Kandivali",
      university: "Mumbai University",
      year: "2007"
    },
    {
      degree: "B.Sc (Computer Science)",
      institution: "Royal College, Mira Road",
      university: "Mumbai University",
      year: "2005"
    },
    {
      degree: "HSC",
      institution: "Royal College, Mira Road",
      board: "Maharashtra Board",
      year: "2002"
    },
    {
      degree: "SSC",
      institution: "St. Xavier's High School",
      board: "Maharashtra Board",
      year: "2000"
    }
  ],

  contact: {
    title: "Let's Connect",
    description: "Interested in discussing algorithmic trading solutions, technology leadership, or potential collaborations? I'd love to hear from you.",
    email: "brainzz@gmail.com",
    social: [
      {
        platform: "LinkedIn",
        url: "https://www.linkedin.com/in/akhil-jain-0b173519/",
        username: "akhil-jain-0b173519"
      },
      {
        platform: "GitHub",
        url: "https://github.com/brainzz-2285?tab=repositories",
        username: "brainzz-2285"
      }
    ]
  }
};